
const CircuitFileList = ({ circuit_files, input_files, activeFileIndex, onFileClick, onCreateNew }) => {

  const fileIcon = (type) => {
    switch (type) {
      case 'code':
        return 'fa-file-code';
      case 'input':
        return 'fa-file-lines';
      default:
        return 'fa-gear';
    }
  };

  return (
    <aside className="menu p-3 py-4 is-flex is-flex-direction-column column is-2" 
      style={{ borderRight: '1px solid #e5e7eb' }}>
      <div className="menu-label">
        <span className="has-text-weight-semibold">Files</span>
        <button
          className="button is-small is-pulled-right"
          onClick={() => onCreateNew("code")}
        >
          <span className="icon mr-0">
            <i className="fa-solid fa-plus" />
          </span>
          Add File
        </button>
      </div>

      <ul className="menu-list" 
      style={{minHeight: '250px', maxHeight: '500px', overflow: 'scroll', resize: 'vertical'}}>
        {circuit_files.map((file, index) => (
          <li key={file.id || index} className="is-size-7">
            <a
              className={activeFileIndex === (index) ? 'is-active p-0' : 'p-0'}
              onClick={() => onFileClick(file.id)}
            >
              <span className="icon mr-0">
                <i className={`fa-regular ${fileIcon(file.type)}`} />
              </span>
              {file.name}.{file.extension}
            </a>
          </li>
        ))}
      </ul>

      {/* Resizable handle */}
      <hr/>
      <div className="menu-label">
        <span className="has-text-weight-semibold">Inputs</span>
        <button
          className="button is-small is-pulled-right"
          onClick={() => onCreateNew("input")}
        >
          <span className="icon mr-0">
            <i className="fa-solid fa-plus" />
          </span>
          Add File
        </button>
      </div>
      <ul className="menu-list mb-auto" style={{ height: '250px', overflow: 'scroll' }}>
        {input_files.map((file, index) => (
          <li key={file.id || index} className="is-size-7">
            <a
              className={activeFileIndex === (circuit_files.length + index) ? 'is-active p-0' : 'p-0'}
              onClick={() => onFileClick(file.id)}
            >
              <span className="icon mr-0">
                <i className={`fa-regular ${fileIcon(file.type)}`} />
              </span>
              {file.name}.{file.extension}
            </a>
          </li>
        ))}
      </ul>


      {/* <div className="menu-label">
        <span className="has-text-weight-semibold">Settings</span>
      </div>
      <button className="button is-danger is-small" onClick={onDelete}>
        <span className="icon mr-0">
          <i className="fas fa-trash" />
        </span>
        Delete Circuit
      </button> */}
    </aside>
  );
};

export default CircuitFileList;
